module.exports = __webpack_public_path__ + "static/img/img13.3735b1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img13.jpg
// module id = yQYC
// module chunks = 1